<template>
  <div class="row mt-md-1 mt-sm-1 mt-lg-1">
    <div class="col-xs-6 col-sm-6 start-xs start-sm" v-show="!loading">
      <div class="container-buttons">
        <b-dropdown :text="selected.text" variant="primary" size="sm">
          <b-dropdown-item-button v-for="(chart, i) in colNames" :key="chart.value"
            @click="changeDropdownLeft(chart, i)" :disabled="selectedRight && selectedRight.text == chart.text">
            {{ chart.text }}
          </b-dropdown-item-button>
        </b-dropdown>
        <b-dropdown :text="!selectedRight.value ? 'SELECIONAR' : selectedRight.text"
          :disabled="selected.text === 'VOLUME' || selected.text === 'LÂMINA'" variant="success" size="sm"
          class="ml-md-2" v-if="colNames.length > 1">
          <b-dropdown-item-button v-for="(chart, i) in colNamesRight" :key="i" @click="selectedRight = chart" :disabled="
            chart.text == selected.text &&
            selected.text === colNamesRight[i].text
          ">
            {{ chart.text }}
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>

    <div class="col-xs-6 col-sm-6 end-xs btn-left" v-show="!loading">
      <b-btn-group>
        <b-btn v-for="p in periods" :key="p" size="sm" variant="primary" @click="changeDataByPeriod(p)"
          :disabled="p == period">{{ p }}</b-btn>
      </b-btn-group>
    </div>

    <div class="col-xs-12 center-xs graficos">
      <div v-if="!hasChart && loading">
        <spinner /> Desenhando o gráfico. Por favor, aguarde...
      </div>
      {{ noChartWarning }}
      <apexchart v-if="hasChart" width="100%" height="425" :series="series" :options="options"></apexchart>
    </div>

    <div class="col-xs-12 highlights ml-2 row">
      <div class="col-xs-12 p-0 row around-xs card-container" v-for="(highlight, index) in highlights" :key="index">
        <h5 class="col-xs-12 card-name p-1 m-0" :style="`background-color:${highlight.color};color:#fff`">
          {{ highlight.name }}
        </h5>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.min }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Mínimo</div>
          <span class="hl-detail">
            {{ formatDate(highlight.minDates) }}
          </span>
        </div>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.avg }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Média</div>
          <div class="hl-detail">{{ highlight.length + " leituras" }}</div>
        </div>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.max }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Máximo</div>
          <span class="hl-detail">
            {{ formatDate(highlight.maxDates) }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-xs-12 mt-2 mr-2">
      <TabulatorEvents v-if="eventList.length" :data="eventList" :chart-mounted="isChartMounted"
        :is-mobile="isMobile" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { monitChart } from "@/api";
import TabulatorEvents from "@/pages/components/shared/TableEvents.vue";
// import { cookies } from "@/pages/components/cookies";
import { organizeLog } from "@/pages/components/monit/charts";
export default {
  name: "actuator-charts",
  components: {
    TabulatorEvents,
  },
  props: {
    eqp: String,
    name: String,
    colNames: Array,
    columns: Array,
    showAxesZero: {
      type: Boolean,
      value: false,
    },
    currentlyValues: Object,
    area: Number,
    items: [Object, Array],
    isMobile: Boolean,
  },
  data() {
    return {
      period: "7d",
      periods: ["30min", "1h", "1d", "3d", "7d"],
      loading: true,
      controller: null,
      noChartWarning: "",
      hasChart: false,
      hasCharts: false,
      apex: null, //apex
      selected: null,
      selectedRight: null,
      isChartMounted: false,
      info: {},
      series: [],
      options: {},
      colNamesRight: [],
      // serieNameChart: "",
      colNamesRight: [],
      colorChart: {
        type: "solid",
        opacity: 0.1,
        gradient: {
          type: "vertical",
          shade: "dark",
          shadeIntensity: 0.5,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 50, 100],
        },
      },
      annotationChartDate: "",
      annotationChartTime: "",
      annotationChartData: "",
      annotationChartNote: "",
      tableData: [],
      minDate: "",
      maxDate: "",
      eventList: [],
    };
  },
  created() {
    window.moment = moment;
    this.selected = this.colNames[0];
    this.colNamesRight = this.colNames
      .map((e) => e)
      .filter((e) => e.text !== "VOLUME" && e.text !== "LÂMINA");
    this.colNamesRight.unshift({ value: "", text: "SELECIONAR" });
    // this.selectedRight = this.colNames[1] ? this.colNames[1] : this.colNames[0];
    this.selectedRight = { value: null, text: "SELECIONAR" };
    this.controller = new AbortController();
    if (this.eqp) this.callChart(this.eqp, this.name, this.columns);
    else {
      this.loading = false;
      this.hasChart = false;
      this.noChartWarning = "Não foi identificado o equipamento do gráfico.";
    }
  },
  beforeDestroy() {
    this.controller.abort();
    this.$emit("reset");
  },
  watch: {
    annotationChartDate(v) {
      console.log("DATE ", v);
    },
    selectedRight(newValue) {
      if (this.period != "7d") {
        this.period = "7d";
      }
      if (newValue.text === "SELECIONAR") {
        if (this.series.length > 1) {
          this.selectedRight = { value: null, text: "SELECIONAR" };
          this.buildActuatorInfo();
        }
      } else if (newValue.value && this.series[0] && this.series[0].name) {
        this.buildActuatorInfoRight();
      }
    },
  },
  computed: {
    highlights() {
      let highlights = [];
      for (let i = 0; i < this.series.length; i++) {
        let pos = null;
        if (this.series[i].data && this.series[i].data.length) {
          let logs = this.series[i].data.map((e) => Number(e[1]));
          let max = Math.max(...logs);
          let min = Math.min(...logs);
          let avg = (logs.reduce((acc, e) => acc + e, 0) / logs.length).toFixed(
            2
          );
          let length = logs.length;
          if (
            (i === 0 && this.selected.text === "VAZÃO") ||
            (i === 1 && this.selectedRight.text === "VAZÃO")
          ) {
            let logsNotNull = logs.filter((e) => !!e);
            length = logsNotNull.length;
            if (logsNotNull.length) {
              avg = (
                logsNotNull.reduce((acc, e) => acc + e, 0) / logsNotNull.length
              ).toFixed(2);
              min = Math.min(...logsNotNull);
            }
          }
          let maxDates = this.series[i].data
            .filter((e) => e[1] == max)
            .map((e) => e[0]);
          let minDates = this.series[i].data
            .filter((e) => e[1] == min)
            .map((e) => e[0]);
          if (
            highlights.push({
              name: this.series[i].name,
              unit: this.series[i].unit,
              pos,
              max,
              maxDates,
              min,
              minDates,
              avg,
              length,
              color: this.series[i].c,
            }) == this.series.length
          ) {
            return highlights;
          }
        } else {
          if (
            highlights.push({
              name: this.series[i].name,
              unit: this.series[i].unit,
              pos,
              max: "?",
              maxDates: "",
              min: "?",
              minDates: "",
              avg: "?",
              length: "?",
              color: this.series[i].c,
            }) == this.series.length
          )
            return highlights;
        }
      }
    },
  },
  methods: {
    createTable(data) {
      // this.showTabulator = false;
      this.tableData = [];
    },
    changeDropdownLeft(newValue) {
      if (newValue) {
        this.selected = newValue;
        this.options = {};
        this.series = [];
        this.hasChart = false;
        this.hasCharts = false;
        this.period = "7d";
        if (
          this.selected.text === "VOLUME" ||
          this.selected.text === "LÂMINA"
        ) {
          this.selectedRight = { value: null, text: "SELECIONAR" };
        }
        this.buildActuatorInfo();
        if (this.selectedRight.value != null) {
          this.buildActuatorInfoRight();
        }
      }
    },
    formatDate(unix) {
      if (unix) {
        if (unix.length == 1) return moment(unix[0]).format("DD/MM/YYYY HH:mm");
        else
          return `${moment(unix[unix.length - 1]).format("DD/MM/YYYY HH:mm")}`;
      }
    },
    changeDataByPeriod(p) {
      this.period = p;
      let now = moment();
      let today0h = moment({ hour: 0, minute: 0, seconds: 0, milliseconds: 0 });
      let period = null;
      switch (p) {
        case "7d":
          if (this.selectedRight) {
            this.buildActuatorInfoRight();
          } else {
            this.buildActuatorInfo();
          }
          break;
        case "3d":
          period = today0h.subtract(3, "days").format("YYYY-MM-DD HH:mm");
          if (this.selectedRight) {
            this.buildActuatorInfoRight(period);
          } else {
            this.buildActuatorInfo(period);
          }
          break;
        case "1d":
          period = today0h.subtract(1, "days").format("YYYY-MM-DD HH:mm");
          if (this.selectedRight) {
            this.buildActuatorInfoRight(period);
          } else {
            this.buildActuatorInfo(period);
          }
          break;
        case "1h":
          period = now.subtract(1, "hours").format("YYYY-MM-DD HH:mm");
          if (this.selectedRight) {
            this.buildActuatorInfoRight(period);
          } else {
            this.buildActuatorInfo(period);
          }
          break;
        case "30min":
          period = now.subtract(30, "minutes").format("YYYY-MM-DD HH:mm");
          if (this.selectedRight) {
            this.buildActuatorInfoRight(period);
          } else {
            this.buildActuatorInfo(period);
          }
          break;
      }
    },
    getTimestamp(datetime) {
      let dt = datetime.replace(/ /g, "T");
      return Math.round(new Date(dt).getTime());
    },
    buildActuatorInfo(p) {
      if (Object.keys(this.info).length) {
        let filter = 0;
        if (p) filter = this.getTimestamp(p);
        let name = this.info.name;
        let { data, type, measure, unit, max, min, curve } =
          this.info[this.selected.value];
        this.series = [
          {
            name: `Leituras de ${measure}`,
            unit,
            data: this.generateDataChart(data, filter),
            c: "#007bff",
          },
        ];
        this.options = {
          chart: {
            id: `apexchart`,
            height: 425,
            width: "100%",
            type: this.changeTypeChart(this.selected.text),
            // type: this.selected.text === "VOLUME" || this.selected.text === "LÂMINA"?'bar':'line',
            stacked: false,
            zoom: {
              enabled: true,
              autoScaleYaxis: true,
            },
            animations: {
              enabled: false,
            },
            events: {
              mounted: () => {
                if (!this.isChartMounted) {
                  this.isChartMounted = true;
                }
                return;
              },
            },
            toolbar: {
              export: {
                csv: {
                  headerCategory: "Data",
                  filename: "Dados do gráfico",
                  dateFormatter(timestamp) {
                    return moment(timestamp).format("DD/MM/YYYY HH:mm");
                  },
                },
              },
              offsetY: -2,
            },
          },
          xaxis: {
            type: "datetime",
            labels: {
              datetimeUTC: false,
              format: "dd/MM/yyyy HH:mm",
              rotateAlways: false,
            },
          },
          stroke: {
            curve: "smooth",
            width: [2, 2, 2],
            // width: [4, 4],
          },
          title: {
            text: `${name} - ${measure} (${unit ? unit : "Sem unidade"})`,
            align: "left",
            offsetX: 10,
            offsetY: 15,
          },
          dataLabels: {
            enabled: false,
          },
          yaxis: [
            {
              min: 0,
              axisTicks: {
                show: false,
              },
              logarithmic: false,
              opposite: false,
              axisBorder: {
                show: false,
                color: "#000",
              },
              labels: {
                // minWidth: 20,
                offsetX: 0,
                align: "left",
                rotate: 0,
                style: {
                  fontSize: "10px",
                  colors: "#008FFB",
                },
                formatter: function (value) {
                  return `${value.toFixed(2)}`;
                },
              },
              title: {
                // text: ``,
                show: false,
                style: {
                  color: "#008FFB",
                },
              },
              min: 0,
            },
          ],
          annotations: {
            yaxis: [],
          },
          tooltip: {
            x: {
              show: true,
              format: "dd/MM/yyyy HH:mm",
            },
            y: {
              formatter: function (value) {
                return `${value.toFixed(2)} `;
              },
            },
            markers: {
              size: 0,
              style: "hollow",
            },
          },
          legend: {
            show: false,
          },
        };
        if (!this.selectedRight.value) {
          this.options.fill = { ...this.colorChart };
        } else if (this.selectedRight.value) {
          this.options.fill = { ...this.colorChart };
          this.options.fill.opacity = 1;
        }
        setTimeout((_) => {
          this.loading = false;
          this.hasChart = true;
        }, 150);
      }
    },
    buildActuatorInfoRight(p) {
      if (Object.keys(this.info).length) {
        p ? this.buildActuatorInfo(p) : this.buildActuatorInfo();
        let filter = 0;
        if (p) filter = this.getTimestamp(p);
        let name = this.info.name;
        let { data, type, measure, unit, max, min, curve } =
          this.info[this.selectedRight.value];
        let series = [];
        series = [
          {
            name: `Leituras de ${measure}`,
            unit,
            type: "line",
            data: this.generateDataChart(data, filter),
            c: "#4ba05f",
          },
        ];
        let options = {
          yaxis: {
            min: 0,
            axisTicks: {
              show: false,
            },
            logarithmic: false,
            opposite: false,
            axisBorder: {
              show: false,
              color: "#000",
            },
            title: {
              show: false,
              style: {
                color: "#28a745",
              },
            },
            labels: {
              offsetX: -10,
              style: {
                fontSize: "10px",
                colors: "#28a745",
              },
            },
          },
        };
        if (series.length > 1) {
          series.forEach((e) => {
            this.series.push(e);
          });
        } else {
          this.series.push(series[0]);
        }
        this.options.yaxis.push(options.yaxis);
      }
    },
    generateDataChart(data, filter) {
      let result;
      try {
        if (data.length) {
          result = data.filter((e) => e[0] > filter);
          if (!result.length > 0) {
            throw `Não existe dados para o período de ${this.period} especificado.`;
          }
          return result.length ? result : [];
        } else {
          return data;
        }
      } catch (error) {
        if (this.selectedRight.value !== null) {
          alert(error);
          this.buildActuatorInfo();
          this.buildActuatorInfoRight();
        } else {
          alert(error);
          this.buildActuatorInfo();
        }
        return [];
      }
    },
    organizeEventsInfo(logs) {
      let formatData = [];
      logs = logs.filter((log) => {
        return !!log.NOTE;
      });
      formatData = logs.map(({ NOTE, TIME }) => {
        return { NAME: TIME, VALUE: NOTE };
      });
      formatData.sort(function (a, b) {
        var c = new Date(a.NAME);
        var d = new Date(b.NAME);
        return d - c;
      });
      this.eventList = formatData;
    },
    callChart(EQP, NAME, columns) {
      let START = moment()
        .subtract(1, "week")
        .hours(0)
        .minutes(0)
        .format("YYYY-MM-DD HH:mm");
      let END = moment().format("YYYY-MM-DD HH:mm");
      let len = columns.length;
      let data = {
        EQP,
        NAME,
        COLUMN: EQP != "SENSOR" ? columns : "UNIT",
        CONDITION:
          EQP != "SENSOR"
            ? "where"
            : {
              TYPES: columns.map((e) => e.TYPE),
              UNITS: columns.map((e) => e.UNIT),
            },
        START,
        END,
      };
      monitChart
        .create(data, this.controller)
        .then((ret) => {
          if (ret && ret.value && ret.value[0] && ret.value[0] && ret.value[0][0].IS_FIR) {
            ret.value[0].map(log => {
              if (log.NOTE && log.NOTE.toUpperCase().includes("DESATIVADO")) {
                log.OPEN = 1;

              } else if (log.NOTE && log.NOTE.toUpperCase().includes("ATIVADO") || log.OPEN) {
                log.VOL_VALUE = 0;
                log.OPEN = 1;

              } else {
                log.OPEN = 0;
                log.VOL_VALUE = 0;
              }

              return log;
            })
          }

          let result = ret;
          if (result.value[0].length && result.status) {
            return Promise.all([
              organizeLog(
                result,
                EQP,
                NAME,
                this.columns,
                null,
                this.area
              ).catch((err) => Promise.reject(err)),
              Promise.resolve(
                Array.isArray(result.value[1]) ? result.value[0] : result.value
              ),
            ]);
          } else {
            alert(result.log, "w");
            throw new Error(result.log);
          }
        })
        .then(([reportData, logs]) => {
          // if (e.status) this.drawApexSyncCharts(e.value); //apex sync
          if (reportData.status) {
            this.info = reportData.value;
            this.buildActuatorInfo();
            if (this.selectedRight.value) {
              this.buildActuatorInfoRight();
            }
          } else {
            this.loading = false;
            this.hasChart = false;
            this.noChartWarning = reportData.log;
          }
          return logs;
        })
        .then((logs) => this.organizeEventsInfo(logs))
        .catch((err) => {
          this.loading = false;
          this.hasChart = false;
          console.error(err);
          this.noChartWarning = "Não foi possível desenhar o gráfico.";
        });
    },
    changeTypeChart(type) {
      if (type === "VOLUME" || type === "LÂMINA") {
        return "bar";
        // return "line";
      } else if (this.selectedRight.value === null) {
        return "area";
      } else if (this.selectedRight.value) {
        return "line";
      }
    },
  },
};
</script>

<style scoped>
.graficos {
  min-height: 425px;
}

.apexcharts-tooltip {
  background: #cf9191;
  color: orange;
}

.chart-div {
  position: relative;
}

.highlights h4 {
  margin: 0;
}

.highlights .hl-detail {
  display: block;
  font-size: 12px;
  color: #777;
}

.container-buttons-left {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.highlights div:first-child {
  margin-bottom: 4px;
}

.highlights .card-name {
  margin-bottom: 8px;
  padding-bottom: 4px;
  font-size: 1.2em;
  padding: 4px 2px;
  text-align: center;
}

.card-container {
  border: solid 1px #dedede;
  padding: 0 -14px;
}

.label {
  display: none;
}

@media (max-width: 767px) {
  .container-dropdown {
    padding-top: 0em;
  }

  .btn-left {
    padding: 0;
  }

  .container-buttons .dropdown+.dropdown {
    margin-top: 4px;
  }
}
</style>
